import graphqlRequest from "../skillsMasteryRequest";
import { SkillMetadata } from "@/models";
const GET_SKILLS_METADATA = `
query GetSkillsMetadata($skillIds: [ID!]!) {
  skillsMetadata: getSkillsMetadata(skillIds: $skillIds) {
    skillId,
    preReqSkills,
    timeToMaster,
  }
}
`;
export async function getSkillsMetadata(skillIds: string[]): Promise<{skillsMetadata: SkillMetadata[]}> {
  return await graphqlRequest(GET_SKILLS_METADATA, { skillIds });
}
